import { render, staticRenderFns } from "./outBillOrderInfo.vue?vue&type=template&id=52d87620&scoped=true&"
import script from "./outBillOrderInfo.js?vue&type=script&lang=js&"
export * from "./outBillOrderInfo.js?vue&type=script&lang=js&"
import style0 from "./outBillOrderInfo.vue?vue&type=style&index=0&id=52d87620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d87620",
  null
  
)

export default component.exports